import {
  IBloodHome,
  IBloodReviews,
  IRequestBloodHomeReview,
} from '@src/interfaces/blood';
import { BloodKeys } from '@src/keys/bloodKey';
import { blood } from '@src/services/api';
import {
  UseMutationResult,
  UseQueryResult,
  useMutation,
  useQuery,
} from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useRouter } from 'next/router';

const useBlood = () => {
  const fetchBloodReviews = (): UseQueryResult<IBloodReviews, AxiosError> => {
    return useQuery(BloodKeys.reviews, () => blood.getBloodReviews());
  };

  // 헌혈의집 리뷰 작성 검색 function
  const fetchBloodHome = (
    keyword?: string
  ): UseQueryResult<IBloodHome[], AxiosError> => {
    return useQuery(
      [...BloodKeys.home, { keyword }],
      () => blood.getBloodHome(keyword),
      {
        enabled: !!keyword,
      }
    );
  };

  const createBloodHomeReview = () => {
    const router = useRouter();
    return useMutation(async (request: IRequestBloodHomeReview) => {
      const res = await blood.createBloodHomeReview(request);
      if (res.status === 200) {
        router.push('/community/board');
      } else {
        alert('작성을 실패했습니다.');
      }
    });
  };

  const updateBloodHomeReview = () => {
    const router = useRouter();
    return useMutation(async (request: IRequestBloodHomeReview) => {
      const res = await blood.updateBloodHomeReview(request, request.uuid);
      if (res.status === 200) {
        router.push(`/community/board/detail/${request.uuid}`);
      } else {
        alert('수정을 실패했습니다.');
      }
    });
  };

  // 헌혈의집 리뷰리스트 조회 function
  const fetchBloodHomeList = (
    keyword?: string
  ): UseQueryResult<IBloodHome[], AxiosError> => {
    return useQuery([...BloodKeys.home, { keyword }], () =>
      blood.getBloodHome(keyword)
    );
  };

  const fetchSelectBloodHomeList = (bloodHomeUuid: string) => {
    return useQuery([...BloodKeys.selectBloodHome, bloodHomeUuid], () => {
      blood.getSelectBloodHomeReviews(bloodHomeUuid, 0, '');
    });
  };

  return {
    fetchBloodReviews,
    fetchBloodHome,
    createBloodHomeReview,
    updateBloodHomeReview,
    fetchBloodHomeList,
    fetchSelectBloodHomeList,
  };
};

export default useBlood;
